import { COMMENTS_LAYOUT_MODE, CommentsLayoutComponent, COMMON_TOOL_WIDGETS } from '@75f/comments';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastMessageComponent } from '../toast-message/toast-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-comments-layout-wrapper',
  imports: [CommentsLayoutComponent],
  templateUrl: './comments-layout-wrapper.component.html',
  styleUrl: './comments-layout-wrapper.component.scss'
})
export class CommentsLayoutWrapperComponent implements OnInit{
  @Input() componentId: string = '';
  @Input() componentName: string = '';
  @Input() componentType: COMMON_TOOL_WIDGETS = COMMON_TOOL_WIDGETS.NONE;
  @Input() layoutMode: COMMENTS_LAYOUT_MODE = COMMENTS_LAYOUT_MODE.PANEL;
  @Input() showWhiteHeader: boolean = false;
  @Input() componentOwnerId: string = '';
  @Output() closePanel = new EventEmitter<any>();
  userId: string = '';
  isComponentOwner: boolean = false;
  constructor(public commonService: CommonService, private toastMessage: MatSnackBar) { }

  ngOnInit() {
    let userId = this.commonService.userDetails
      ? this.commonService.userDetails.userId ?? ''
      : '';
    this.userId = userId;
    this.isComponentOwner = this.componentOwnerId === userId;
  }

  // Close Comments Panel
  closeCommentsPanel() {
    this.closePanel.emit();
  }

  // Handle Error Event from Comments Layout
  handleError(event: any) {
    this.showToast('error', event);
  }

  // Toast Message 
  showToast(type: string, message: string) {
    this.toastMessage.openFromComponent(ToastMessageComponent, {
      duration: 5000,
      data: {
        type: type,
        message: message
      },
    });
  }
}
